export default "__VITE_ASSET__f0af58d3__"